import React, { useEffect, createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./header.css";

import logo from "./img/logo.svg";
import logoDark from "./img/logo-dark.svg";
import burger from "./img/burger.svg";
import burgerDark from "./img/burger-dark.svg";
import close from "./img/close.svg";
import closeDark from "./img/close-dark.svg";
import logout from "./img/logout.svg";
import logoutDark from "./img/logout-dark.svg";
import sun from "./img/sun.svg";
import sunDark from "./img/sun-dark.svg";
import moon from "./img/moon.svg";
import moonDark from "./img/moon-dark.svg";

const StorageKey = "features-color-theme";
const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error(
      'You can use "useTheme" hook only within a <ThemeProvider> component.'
    );
  }

  return context;
};

const updateThemeColor = (currentTheme) => {
  const metaThemeColor = document.getElementById('theme-color');

  if (!metaThemeColor) return;

  let bgColor;

  if (currentTheme === 'light') {
    bgColor = '#ffffff';
  } else if (currentTheme === 'dark') {
    bgColor = '#151515';
  }

  if (bgColor) {
    metaThemeColor.setAttribute('content', bgColor);
  }
};

// Провайдер для управления темой
const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Получаем текущую тему из localStorage или устанавливаем по умолчанию "light"
    const storedTheme = localStorage.getItem("features-color-theme");
    return storedTheme || "light";
  });

  // Сохраняем выбранную тему в localStorage
  useEffect(() => {
    localStorage.setItem("features-color-theme", theme);
    document.documentElement.setAttribute("data-theme", theme); // Устанавливаем атрибут на HTML элементе

    updateThemeColor(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

const Header = () => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    localStorage.setItem(StorageKey, theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    navigate("/");
  };

  const handleOpenMenu = () => {
    setOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  const enableLightTheme = () => {
    setTheme("light");
  };

  const enableDarkTheme = () => {
    setTheme("dark");
  };

  return (
    <header className="header">
      <img
        className="logo"
        src={theme === "light" ? logo : logoDark}
        alt="logo"
      />

      <div className="rightHeader">
        <div className={"themeToggler"}>
          <img
            className={`themeIcon ${theme === "light" ? "active" : ""}`}
            src={theme === "light" ? sun : sunDark}
            alt="light"
            onClick={enableLightTheme}
          />
          <img
            className={`themeIcon ${theme === "dark" ? "active" : ""}`}
            src={theme === "light" ? moon : moonDark}
            alt="dark"
            onClick={enableDarkTheme}
          />
        </div>

        <div className="burger">
          {!openMenu && (
            <img
              src={theme === "light" ? burger : burgerDark}
              onClick={() => handleOpenMenu()}
              alt="burger"
            />
          )}
          {openMenu && (
            <img
              src={theme === "light" ? close : closeDark}
              onClick={() => handleCloseMenu()}
              alt="close"
            />
          )}
        </div>
      </div>

      {openMenu && (
        <div className="menu">
          <ul>
            <li className="menuItem">
              <Link to={"/personal-info"}>Personal Information</Link>
            </li>
            <li className="menuItem">
              <Link to={"/transaction-history"}>Transaction History</Link>
            </li>
            <li className="menuItem">
              <div className="btnLogout" onClick={handleLogout}>
                <div>Logout</div>
                <img
                  src={theme === "light" ? logout : logoutDark}
                  alt="logout"
                />
              </div>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export { ThemeProvider };
export default Header;
